import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import PlanningVersionUpgradeResponse from './PlanningVersionUpgradeResponse';


const PlanningVersionUpgradeResponseContainer = ({
  relationshipLink,
}) => {
  const {
    loadingError, collection, refreshCollection, isInitializing,
  } = useLink(relationshipLink);

  return (
    <DataContainer
      component={PlanningVersionUpgradeResponse}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        collection,
        refreshCollection,
      }}
    />
  );
};

PlanningVersionUpgradeResponseContainer.propTypes = {
  relationshipLink: PropTypes.object.isRequired,
};

export default PlanningVersionUpgradeResponseContainer;
